import React from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddCountryForm from '../../../components/forms/country/AddCountryForm';
import PageHeader from '../../../components/common/PageHeader';

export default function AddCountry() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'国登録'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/countries'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddCountryForm />
            </Box>
        </>   
    )
}
